import React, { useContext, useEffect, useState } from "react";
import { useForm, FormProvider, Controller } from "react-hook-form";
import {
  Container,
  Body,
  Header,
  LabelCase,
  TypeCase,
  TypeContainer,
  TypePerson,
  TypePersonContainer,
  Button,
  CurrentState,
  CurrentStep,
  Fotter,
  Instruction,
  Loading,
  Title,
  Row,
  Location,
  Contact,
  Column,
  Label,
  TextField,
  TextArea,
  Line,
} from "./style";
import Natural from "@pages/NewPQRS/Step2/Natural";
import Legal from "@pages/NewPQRS/Step2/Legal";
import { TypesPage } from "@context/types/page";
import { AppContext } from "@context";
import { TypesPersonality } from "@context/types/legalpersonality";
import { IFormPatient } from "@pages/NewPQRS/Step2/interface";
import {
  getCities,
  getCountries,
  getStates,
} from "@api/services/parameterization";
import { IOptions } from "@components/form/Select/interface";
import Select from "@components/form/Select";
import { Error } from "@pages/NewPQRS/Step1/style";
//constant
import { responseType, streeNameList } from "@utils/constant/select.ts";
import { TypesPatient } from "@context/types/patient";
import { TypesAnonymous } from "@context/types/anonymous";
import { useLocation } from "react-router-dom";
import { TypesLoading } from "@context/types/loading";
const Step2 = () => {
  const { state, dispatch } = useContext(AppContext);
  const [country, setCountry] = useState<IOptions[]>([]);
  const [states, setstates] = useState<IOptions[]>([]);
  const [city, setCity] = useState<IOptions[]>([]);
  const { islegal, patient, anonymous } = state;
  const { natural, legal, ...other } = patient;
  const initialValues = { ...natural, ...legal, ...other };
  const methods = useForm<IFormPatient>({
    defaultValues: initialValues,
    shouldUnregister: true,
  });
  const { register, handleSubmit, errors, watch, control, setValue } = methods;
  const values = watch(["country", "state", "city"]);
  const relation = watch("relationshipType");
  const currentMeans = watch("means");
  const location = useLocation();
  const typeIssue = (location.state as { type: number }).type;
  const isCongratsOrSugestion = typeIssue === 4 || typeIssue === 3;
  const goBack = () => {
    dispatch({ type: TypesPage.Previous });
  };

  const selectLegal = () => {
    dispatch({ type: TypesPersonality.Legal });
    dispatch({ type: TypesPage.Reset });
    dispatch({ type: TypesAnonymous.NotAnonymous });
  };
  const selectNatural = () => {
    dispatch({ type: TypesPersonality.Natural });
    dispatch({ type: TypesPage.Reset });
  };
  const onSave = (values: IFormPatient) => {
    const data = {
      country: values.country,
      state: values.state,
      city: values.city,
      streetName: values.streetName,
      neighborhood: values.neighborhood,
      address: values.address,
      addressDetail: values.addressDetail,
      phone: values.phone,
      email: values.email,
      means: values.means,
      natural: {
        name: values.name,
        lastName: values.lastName,
        bond: values.bond,
        docType: values.docType,
        documemt: values.documemt,
        relationshipType: values.relationshipType,
        relationship: values.relationship,
      },
      legal: { entity: values.entity, entityType: values.entityType },
    };
    dispatch({ type: TypesPatient.Save, payload: data });
    dispatch({ type: TypesPage.Next });
  };
  useEffect(() => {
    (async () => {
      try {
        dispatch({ type: TypesLoading.Loading });
        const responseCountry = await getCountries();
        const countries = responseCountry.map(({ id, name }) => ({
          value: id,
          label: name,
        }));
        setCountry(countries);
        dispatch({ type: TypesLoading.NotLoading });
      } catch (err) {
        dispatch({ type: TypesLoading.NotLoading });
      }
    })();
  }, []);
  useEffect(() => {
    (async () => {
      try {
        dispatch({ type: TypesLoading.Loading });
        const responseState = await getStates(values.country.value);
        const states = responseState.map(({ id, name }) => ({
          value: id,
          label: name,
        }));
        setstates(states);
        const responseCity = await getCities(
          values.country.value,
          values.state.value
        );
        const cities = responseCity.map(({ id, name }) => ({
          value: id,
          label: name,
        }));
        setCity(cities);
        dispatch({ type: TypesLoading.NotLoading });
      } catch (err) {
        dispatch({ type: TypesLoading.NotLoading });
      }
    })();
  }, [values.country.value, values.state.value]);
  const handleSelectChange = (option: IOptions, name: string) => {
    setValue(name, option);
  };
  console.log(errors, "Erros");
  console.log(Number(relation), "sdlfsdfknk");
  console.log(Number(relation) !== 0, "sdlfsdfknk");
  return (
    <FormProvider {...methods}>
      <Container onSubmit={handleSubmit(onSave)}>
        <Header>
          <TypeContainer>
            <LabelCase>Radicar Nuevo Caso</LabelCase>
            <TypeCase color={location.state.color}>
              {location.state.title}
            </TypeCase>
          </TypeContainer>
          <TypePersonContainer>
            <TypePerson onClick={selectNatural} selected={!islegal}>
              Persona natural
            </TypePerson>
            <TypePerson onClick={selectLegal} selected={islegal}>
              Persona jurídica
            </TypePerson>
          </TypePersonContainer>
        </Header>
        <Body>
          <Title>Informacion de Contacto:</Title>
          {islegal ? <Legal /> : <Natural />}
          <Line />
          <Row>
            <Location>
              <Line></Line>
              <Column width={"100%"}>
                <Label>
                  Pais *
                  <Controller
                    as={Select}
                    options={country}
                    placeholder={"Seleccione"}
                    name={"country"}
                    control={control}
                    rules={
                      isCongratsOrSugestion
                        ? { required: false }
                        : { required: !anonymous }
                    }
                    onChange={(value: IOptions) => {
                      handleSelectChange(value, "country");
                    }}
                  />
                  {errors.country?.type === "required" && !anonymous && (
                    <Error>Es requerido</Error>
                  )}
                </Label>
                <Label>
                  Departamento *
                  <Controller
                    as={Select}
                    options={states}
                    placeholder={"Seleccione"}
                    name={"state"}
                    control={control}
                    rules={
                      isCongratsOrSugestion
                        ? { required: false }
                        : { required: !anonymous }
                    }
                    onChange={(value: IOptions) => {
                      handleSelectChange(value, "state");
                    }}
                  />
                  {errors.state?.type === "required" && !anonymous && (
                    <Error>Es requerido</Error>
                  )}
                </Label>
                <Label>
                  Municipio *
                  <Controller
                    as={Select}
                    options={city}
                    placeholder={"Seleccione"}
                    name={"city"}
                    control={control}
                    rules={
                      isCongratsOrSugestion
                        ? { required: false }
                        : { required: !anonymous }
                    }
                    onChange={(value: IOptions) => {
                      handleSelectChange(value, "city");
                    }}
                  />
                  {errors.city?.type === "required" && !anonymous && (
                    <Error>Es requerido</Error>
                  )}
                </Label>
              </Column>
              <Line></Line>
              <Column width={"95%"}>
                <Label width={"30%"}>
                  Direccion
                  <Controller
                    as={Select}
                    options={streeNameList}
                    placeholder={"Seleccione"}
                    name={"streetName"}
                    control={control}
                    rules={{ required: false }}
                    onChange={(value: IOptions) => {
                      handleSelectChange(value, "streetName");
                    }}
                  />
                  {errors.streetName?.type === "required" && !anonymous && (
                    <Error>Es requerido</Error>
                  )}
                </Label>
                <Label width={"30%"}>
                  <TextField
                    ref={register({ required: false })}
                    name="address"
                    placeholder="       #      "
                  />
                  {errors.address?.type === "required" && !anonymous && (
                    <Error>Es requerido</Error>
                  )}
                </Label>
                <Label width={"30%"}>
                  <TextField
                    ref={register({ required: false })}
                    name="neighborhood"
                    placeholder="Barrio"
                  />
                  {errors.neighborhood?.type === "required" && !anonymous && (
                    <Error>Es requerido</Error>
                  )}
                </Label>
              </Column>
              <Column width={"100%"}>
                <TextArea
                  ref={register()}
                  name="addressDetail"
                  placeholder="Información Adicional (Este campo es opcional)"
                ></TextArea>
              </Column>
            </Location>
            <Contact>
              <Label width={"90%"}>
                Teléfono de contacto *
                <TextField
                  ref={register(
                    {
                          required:
                            currentMeans?.value == 1 ||
                            currentMeans?.value == 2,
                          minLength: 7,
                        }
                  )}
                  name="phone"
                  type="number"
                  placeholder="Escriba su teléfono o celular"
                />
                {errors.phone?.type === "required" && (
                  <Error>Es requerido</Error>
                )}
                {errors.phone?.type === "minLength" && (
                  <Error>Telefono no valido</Error>
                )}
              </Label>
              <Label width={"90%"}>
                Correo Electrónico *
                <TextField
                  type="email"
                  ref={register(
                     {
                          required:
                            currentMeans?.value == 0 ||
                            currentMeans?.value == 2,
                        }
                  )}
                  name="email"
                  placeholder="Escriba su correo"
                />
                {errors.email?.type === "required" && (
                  <Error>Es requerido</Error>
                )}
              </Label>
              <Label width={"70%"}>
                Medio de Contacto *
                <Controller
                  as={Select}
                  options={responseType}
                  placeholder={"Seleccione"}
                  name={"means"}
                  control={control}
                  rules={
                    { required: true }
                  }
                  onChange={(value: IOptions) => {
                    handleSelectChange(value, "means");
                  }}
                />
                {errors.means?.type === "required" && (
                  <Error>Es requerido</Error>
                )}
              </Label>
            </Contact>
          </Row>
          <Fotter>
            <Instruction>
              Los campos marcados con " * " son obligatorios según la circular
              008 de 2018 de la Superintendencia Nacional de Salud.
            </Instruction>
            <CurrentStep>Paso 2 de 3</CurrentStep>
            <Loading>
              <CurrentState />
            </Loading>
            <div>
              <Button
                color={"#3F4A59"}
                bg={"#FFFFFF"}
                type={"button"}
                onClick={goBack}
              >
                Atras
              </Button>
              <Button type={"submit"}>Siguiente</Button>
            </div>
          </Fotter>
        </Body>
      </Container>
    </FormProvider>
  );
};

export default Step2;
